import React from 'react';

import { Button, Form, Modal } from 'antd';
import { t } from 'i18next';

import { useAppSelector, useNotification } from 'segments/hooks';

import { SelectGroupe } from 'features/groups';
import { useAddUserToGroupeMutation } from 'features/users';
import { selectActiveUserId } from 'features/users/store/usersSlice';

interface FormValues {
  groupeId: number;
}

type Props = {
  handleCancel: () => void;
};

export const SelectUserGroupeModal = (props: Props) => {
  const {
    handleCancel,
  } = props;

  const selectedUserId = useAppSelector(selectActiveUserId);
  const [addUserToGroupe, { isLoading: addingLoading, isSuccess: addingSuccess, isError: addingError, error }] = useAddUserToGroupeMutation();
  const [form] = Form.useForm();

  useNotification({
    isSuccess: addingSuccess,
    isError: addingError,
    error,
    onSuccess: () => {
      handleCancel();
      form.resetFields();
    },
  });


  if (selectedUserId === null) {
    return;
  }

  const onFinish = ({ groupeId }: FormValues) => {
    addUserToGroupe({
      groupeId,
      userId: selectedUserId
    });
  };

  return (
    <Modal
      open
      title={t('user.add-groupe')}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        disabled={addingLoading}
      >
        <SelectGroupe formProps={{
          rules: [{ required: true }]
        }}
        />
        <Button type="primary" htmlType="submit" className="login-form-button">
          {t('user.go', 'Выполнить')}
        </Button>
      </Form>
    </Modal>
  );
};
